import { useVyNavigate } from '../../../../../../hooks/use-vy-navigate/use-vy-navigate';
import { PLAN_CREATE_ROUTE } from '../../../../../../router/routing-consts';
import { CREATE_PLAN_QUERY_PARAMS } from '../../../../CreatePlanPage/create-plan-page-consts/query-params';
import { useCallback } from 'react';

export function useSelectPlanTemplateDialogActions() {
  const navigate = useVyNavigate();

  const goToCreatePlanWithClone = useCallback((planId: string) => {
    navigate(`${PLAN_CREATE_ROUTE}?${CREATE_PLAN_QUERY_PARAMS.CLONE_FROM_PLAN_ID}=${planId}`);
  }, []);

  return { goToCreatePlanWithClone };
}
